import "@/lib/freshSession";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { fitPrintToOnePage, resetPrintFit } from "@/lib/printFit";

let titleBeforePrint;
window.addEventListener("beforeprint", () => {
  titleBeforePrint = document.title;
  document.title = "\u00a0";
  try { fitPrintToOnePage(); } catch { /* الطباعة تستمر حتى لو تعذر التصغير */ }
});
window.addEventListener("afterprint", () => {
  resetPrintFit();
  if (titleBeforePrint !== undefined) {
    document.title = titleBeforePrint;
    titleBeforePrint = undefined;
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
